























import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Item bundle PPI 3 nilai: Ya (true) / Tidak (false) / Tidak dinilai (null).
 * Item "tidak dinilai" tidak masuk denominator kepatuhan — sesuai blanko PPI,
 * agar item yang memang tidak diobservasi tidak menekan capaian bangsal.
 */
@Component
export default class BundleItemTriState extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: null }) readonly value!: boolean | null;
  @Prop({ default: false }) readonly disabled!: boolean;

  /**
   * Nilai toggle dibuat eksplisit ("na"), bukan null: v-btn-toggle `mandatory`
   * menganggap null sebagai "belum memilih" lalu memaksa tombol pertama aktif —
   * item yang belum disentuh akan tampak "Ya" (kepatuhan palsu).
   */
  get internal(): string {
    if (this.value === true) return "ya";
    if (this.value === false) return "tidak";
    return "na";
  }

  onChange(val: string | undefined) {
    if (val === "ya") this.$emit("input", true);
    else if (val === "tidak") this.$emit("input", false);
    else this.$emit("input", null);
  }
}
